import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../ContactCell.style';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Button, Chip, IconButton, Tooltip } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { deleteDownloadItem, getDownloadItem, setFilterBundleType } from 'redux/actions/Movies';
import { DynamicFeed } from '@material-ui/icons';
import useSwalWrapper from '@jumbo/vendors/sweetalet2/hook';

const DownloadItemCell = ({ item, movieType }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  const history = useHistory();
  const Swal = useSwalWrapper();

  const params = new URLSearchParams(location.search);

  const downloadId = params.get('download');

  const { quality, id, cost, bundle_items_count, discount_price, subtitle, dubbed } = item;

  const handleDelete = () => {
    Swal.fire({
      title: `آیا از حذف ${quality} مطمعن هستید؟`,
      icon: 'warning',
      iconHtml: '؟',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'حذف',
      cancelButtonText: 'لغو',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => dispatch(deleteDownloadItem(id, downloadId)),
    });
  };

  const handleBundle = () => {
    dispatch(setFilterBundleType({ by_quality: quality }));
    history.push(`/manage-bundle/?q=${quality}&p=${id}`);
  };

  const handleUpdateDownloadItem = () => {
    dispatch(getDownloadItem({ downloadId, id, movieType }, history));
  };

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Box display="flex" alignItems="center">
            <Box>
              <Typography className={classes.titleRoot} component="div" variant="h4">
                {quality}
              </Typography>
            </Box>
          </Box>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        {subtitle ? <Chip label={'زیرنویس'} size="small" color={'secondary'} /> : null}
        {dubbed ? <Chip label={'دوبله'} size="small" color={'primary'} /> : null}
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        {discount_price > 0 ? (
          <>
            <Typography className={classes.discount} component="p">
              {cost}
            </Typography>{' '}
            <Typography className={classes.titleRoot} component="span" variant="h4">
              {discount_price}
            </Typography>
          </>
        ) : (
          cost
        )}{' '}
        تومان
      </TableCell>
      {movieType === 'bundle' ? (
        <>
          <TableCell className={classes.tableCellRoot}>
            {bundle_items_count} <DynamicFeed />
          </TableCell>
          <TableCell className={classes.tableCellRoot}>
            <Button color="primary" variant="outlined" onClick={handleBundle}>
              مدیریت باندل
            </Button>
          </TableCell>
        </>
      ) : null}
      <TableCell className={classes.tableCellRoot}>
        <Tooltip title="ویرایش">
          <IconButton size="small" target="_blank" onClick={handleUpdateDownloadItem}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Tooltip title="حذف">
          <IconButton size="small" target="_blank" onClick={handleDelete}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default DownloadItemCell;

DownloadItemCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
